export default function isSPEmail(email: string): boolean {
  if (email.endsWith('@spglobal.com') || email.endsWith('@ihsmarkit.com')) return true
  return false
}
